import React from "react";

import ProgressBar from "./ProgressBar";

export interface PublicDrawerProps {
  awayPercent: string;
  awayTitle: string;
  awayValue: number;
  homePercent: string;
  homeTitle: string;
  homeValue: number;
  drawValue: number;
  drawPercent: string;
  showData: boolean;
  showDraw: boolean;
}

const PublicDrawer = (props: PublicDrawerProps) => {
  const { awayPercent, awayTitle, awayValue, homePercent, homeTitle, homeValue, showData } = props;

  return (
    <React.Fragment>
      {showData ? <div className="games-table-mobile-row__drawer-title-text">Public</div> : null}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          flexDirection: "row",
        }}
      >
        <div
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            marginRight: 10,
          }}
        >
          <div
            style={{
              fontWeight: "bold",
              fontSize: 13,
              marginBottom: 6,
              color: "#515151",
            }}
          >
            {awayTitle}
          </div>
          <ProgressBar value={showData ? awayValue : 0} align="left" />
          <div
            style={{
              fontWeight: 400,
              fontSize: 13,
              marginBottom: 15,
              color: "#515151",
            }}
          >
            {showData ? awayPercent : "%"}
          </div>
        </div>
        {/* Hiding since not implemented in mobile yet */}
        {/* <div
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginRight: 10,
          }}
        >
          <div
            style={{
              fontWeight: "bold",
              fontSize: 13,
              marginBottom: 6,
              color: "#515151",
            }}
          >
            Draw
          </div>
          <ProgressBar value={(showData && showDraw) ? drawValue : 0} align="left" />
          <div
            style={{
              fontWeight: 400,
              fontSize: 13,
              marginBottom: 15,
              color: "#515151"
            }}
          >
            {showData ? drawPercent : "%"}
          </div>
        </div> */}
        <div
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-end",
          }}
        >
          <div
            style={{
              fontWeight: "bold",
              fontSize: 13,
              marginBottom: 6,
              color: "#515151",
            }}
          >
            {homeTitle}
          </div>
          <ProgressBar value={showData ? homeValue : 0} align="right" />
          <div
            style={{
              fontWeight: 400,
              fontSize: 13,
              marginBottom: 15,
              color: "#515151",
            }}
          >
            {showData ? homePercent : "%"}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default PublicDrawer;
